import * as customerAction from './Customer';
import * as selectAction from './Select';
import * as graphqlAction from './Graphql';
import * as systemParameterAction from './SystemParameter';

/**
 * Reducer
 */
const initialState = {
  loading: false,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case customerAction.DADOSPESSOAIS_ADICIONAR:
    case customerAction.ENDERECO_ADICIONAR:
    case customerAction.PROFISSAO_ADICIONAR:
    case customerAction.DADOSDOCUMENTO_ADICIONAR:
    case customerAction.BIOMETRIA_ADICIONAR:
    case customerAction.DOCUMENTO_VERSO:
    case customerAction.DOCUMENTO_FRENTE:
    case customerAction.VALIDAR_CODIGO_ACESSO:
    case customerAction.BUSCAR_CEP:
    case customerAction.SOLICITAR_CODIGO_SMS:
    case customerAction.VALIDAR_CODIGO_SMS:
    case customerAction.ASSINATURA_CONTRATO:
    case customerAction.CONSULTAR_TERMOS_USO:
    case customerAction.BUSCAR_SEGUROS_DISPONIVEIS:
    case customerAction.ADICIONAR_SEGURO_CONTRATADO:
    case customerAction.BUSCAR_SITUACAO_PORTADOR:
    case customerAction.PRE_AVALIACAO_OBTER:
    case customerAction.DADOSPESSOAIS_PRE_ADICIONAR:
    case selectAction.GET_ESTADOCIVIL:
    case selectAction.GET_CIDADES:
    case selectAction.GET_UF:
    case selectAction.GET_DIADEVENCIMENTO:
    case graphqlAction.GET_FRONT_VALIDATIONACCESSCODE:
    case systemParameterAction.GET_PARAMETRO_SISTEMA:
      return {...initialState, loading: true};

    case customerAction.DADOSPESSOAIS_ADICIONAR_SUCCESS:
    case customerAction.DADOSPESSOAIS_ADICIONAR_FAIL:
    case customerAction.PROFISSAO_ADICIONAR_SUCCESS:
    case customerAction.PROFISSAO_ADICIONAR_FAIL:
    case customerAction.ENDERECO_ADICIONAR_SUCCESS:
    case customerAction.ENDERECO_ADICIONAR_FAIL:
    case customerAction.VALIDAR_CODIGO_ACESSO_SUCCESS:
    case customerAction.VALIDAR_CODIGO_ACESSO_FAIL:
    case customerAction.DADOSDOCUMENTO_ADICIONAR_SUCCESS:
    case customerAction.DADOSDOCUMENTO_ADICIONAR_FAIL:
    case customerAction.BIOMETRIA_ADICIONAR_SUCCESS:
    case customerAction.BIOMETRIA_ADICIONAR_FAIL:
    case customerAction.DOCUMENTO_VERSO_SUCCESS:
    case customerAction.DOCUMENTO_VERSO_FAIL:
    case customerAction.DOCUMENTO_FRENTE_SUCCESS:
    case customerAction.DOCUMENTO_FRENTE_FAIL:
    case customerAction.BUSCAR_CEP_SUCCESS:
    case customerAction.BUSCAR_CEP_FAIL:
    case customerAction.SOLICITAR_CODIGO_SMS_SUCCESS:
    case customerAction.SOLICITAR_CODIGO_SMS_FAIL:
    case customerAction.VALIDAR_CODIGO_SMS_SUCCESS:
    case customerAction.VALIDAR_CODIGO_SMS_FAIL:
    case customerAction.ASSINATURA_CONTRATO_SUCCESS:
    case customerAction.ASSINATURA_CONTRATO_FAIL:
    case customerAction.CONSULTAR_TERMOS_USO_SUCCESS:
    case customerAction.CONSULTAR_TERMOS_USO_FAIL:
    case customerAction.BUSCAR_SEGUROS_DISPONIVEIS_FAIL:
    case customerAction.BUSCAR_SEGUROS_DISPONIVEIS_SUCCESS:
    case customerAction.ADICIONAR_SEGURO_CONTRATADO_SUCCESS:
    case customerAction.ADICIONAR_SEGURO_CONTRATADO_FAIL:
    case customerAction.BUSCAR_SITUACAO_PORTADOR_FAIL:
    case customerAction.BUSCAR_SITUACAO_PORTADOR_SUCCESS:
    case customerAction.PRE_AVALIACAO_OBTER_SUCCESS:
    case customerAction.PRE_AVALIACAO_OBTER_FAIL:
    case customerAction.DADOSPESSOAIS_PRE_ADICIONAR_FAIL:
    case customerAction.DADOSPESSOAIS_PRE_ADICIONAR_SUCCESS:
    case selectAction.GET_ESTADOCIVIL_SUCCESS:
    case selectAction.GET_ESTADOCIVIL_FAIL:
    case selectAction.GET_CIDADES_SUCCESS:
    case selectAction.GET_CIDADES_FAIL:
    case selectAction.GET_UF_SUCCESS:
    case selectAction.GET_UF_FAIL:
    case selectAction.GET_DIADEVENCIMENTO_SUCCESS:
    case selectAction.GET_DIADEVENCIMENTO_FAIL:
    case graphqlAction.GET_FRONT_VALIDATIONACCESSCODE_SUCCESS:
    case graphqlAction.GET_FRONT_VALIDATIONACCESSCODE_FAIL:
    case systemParameterAction.GET_PARAMETRO_SISTEMA_SUCCESS:
    case systemParameterAction.GET_PARAMETRO_SISTEMA_FAIL:
      return {...initialState, loading: false};

    default:
      return state;
  }
};

export default reducer;
